var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3794 6.24048V10.1526L15.7465 11.0134C15.7826 11.024 15.8607 11.0247 15.8968 11.0134L21.7807 7.04649C21.7807 6.577 21.3428 6.24048 21.0956 6.24048H14.3794Z",
    fill: "#0072C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3792 11.6121L15.6269 12.4692C15.8026 12.5984 16.0145 12.4692 16.0145 12.4692C15.8034 12.5984 21.7812 8.62769 21.7812 8.62769V15.8179C21.7812 16.6006 21.2802 16.9289 20.7168 16.9289H14.3784V11.6121H14.3792Z",
    fill: "#0072C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91946 9.80835C7.49429 9.80835 7.15551 10.0082 6.90537 10.407C6.65523 10.8059 6.52979 11.334 6.52979 11.9913C6.52979 12.6583 6.65523 13.1856 6.90537 13.5732C7.15551 13.9616 7.48378 14.1546 7.88941 14.1546C8.30781 14.1546 8.63983 13.9661 8.88472 13.589C9.1296 13.2119 9.25279 12.6883 9.25279 12.0191C9.25279 11.3212 9.1341 10.7781 8.89598 10.3898C8.65786 10.0022 8.3326 9.80835 7.91946 9.80835Z",
    fill: "#0072C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.25352V19.5587L13.6432 22V2L2 4.25352ZM9.79117 14.4935C9.29916 15.141 8.65765 15.4655 7.86592 15.4655C7.09446 15.4655 6.46648 15.1516 5.98047 14.5243C5.49521 13.8963 5.25183 13.0791 5.25183 12.071C5.25183 11.0066 5.49822 10.1457 5.99174 9.48845C6.48526 8.83117 7.13878 8.50216 7.9523 8.50216C8.72075 8.50216 9.34272 8.81615 9.81671 9.44564C10.2915 10.0751 10.5288 10.9044 10.5288 11.9343C10.5296 12.9927 10.2832 13.846 9.79117 14.4935Z",
    fill: "#0072C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/outlook.e653c8fa2311e097a27b49a61dedfe2f.svg";
export { ForwardRef as ReactComponent };